import { Injectable } from '@angular/core';
import { UAParser } from 'ua-parser-js';
import { Observable } from 'rxjs';

@Injectable()
export class UtilsService {
  constructor() {}

  static semanticSorting(valueA, valueB): number {
    if (valueA === null && valueB === null) {
      return 0;
    }
    if (valueA === null) {
      return -1;
    }
    if (valueB === null) {
      return 1;
    }
    return valueA.replace('v', '').replace(/\d+/g, n => +n + 1000) >
      valueB.replace('v', '').replace(/\d+/g, n => +n + 1000)
      ? 1
      : -1;
  }

  static trimAndCaseInsensitiveSorting(valueA = '', valueB = ''): number {
    valueA = valueA.trim().toLowerCase();
    valueB = valueB.trim().toLowerCase();
    return valueA > valueB ? 1 : -1;
  }

  static downloadFile(blob: any, fileName: string): void {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  static resizeObservable(elem: HTMLElement) {
    return new Observable(subscriber => {
      const ro = new (window as any).ResizeObserver(entries => {
        subscriber.next(entries);
      });
      ro.observe(elem);
      function unsubscribe() {
        ro.unobserve(elem);
      }
      return unsubscribe;
    });
  }

  isIE(): boolean {
    const parser = new UAParser();
    const browserName = parser.getBrowser().name;
    return browserName === 'IE' || browserName === 'IE Mobile';
  }

  guid(): string {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return 'ss-s-s-s-sss'.replace(/s/g, s4);
  }
}
